import { render, staticRenderFns } from "./ProductosForm.vue?vue&type=template&id=89092c1c&"
import script from "./ProductosForm.vue?vue&type=script&lang=js&"
export * from "./ProductosForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductosForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports